import React from 'react';
import { Container } from 'components/atoms/Page';
import PropTypes from 'prop-types';
import { H2, Image } from 'components/atoms';
import { PSPLinksCard } from 'components/molecules';
import './PSPLinks.scss';
import MoreWaysToStore from 'assets/images/icons/psp/more-ways-to-store.svg';
import { contentMap } from 'pages/PSPPage/utils/getPSPLinks';
export function PSPLinks({ heading, linksList }) {
	const cards = (linksList || []).map((link) => contentMap[link]);

	return (
		<section className="psp-links">
			<Container>
				{heading && (
					<div className="psp-links__heading">
						<Image
							src={heading.headingImage || MoreWaysToStore}
							alt={heading.headingName || 'Heading icon'}
							className="psp-links__heading-icon"
						/>
						<H2 className="ss-type-megaMobile">
							{heading.headingName}
						</H2>
					</div>
				)}

				<div className="psp-links__cards">
					{cards.map((item, index) => (
						<PSPLinksCard
							item={item}
							index={index}
							key={item.key || index}
						/>
					))}
				</div>
			</Container>
		</section>
	);
}

PSPLinks.propTypes = {
	heading: PropTypes.shape({
		headingName: PropTypes.string.isRequired,
		headingImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	}),
	linksList: PropTypes.array.isRequired,
	id: PropTypes.string,
	type: PropTypes.string,
};

export default PSPLinks;
